import { jsx as _jsx } from "react/jsx-runtime";
import { matchSorter } from 'match-sorter';
import { forwardRef, useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { BASE_SELECT_DEFAULT_MATCH_ORDER } from './BaseSelect.constants';
import { BaseSelectWrapper } from './BaseSelect.styled';
// Component.
// -----------------------------------------------------------------------------
const BaseSelect = forwardRef(({ disabled, mode, multi, name, useMatchSorter = BASE_SELECT_DEFAULT_MATCH_ORDER, noOptionsMessage, onChange, options, placeholder, size, isClearable = true, isCreatable = false, hideDropdownUntilSearch = false, formatCreateLabel, ...rest }) => {
    const [currentOptions, setCurrentOptions] = useState(options);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const handleOnInputChange = (newValue) => {
        if (hideDropdownUntilSearch) {
            setMenuIsOpen(newValue.length > 0);
        }
    };
    useEffect(() => {
        if (options && useMatchSorter) {
            setCurrentOptions(options);
        }
    }, [options, useMatchSorter]);
    return (_jsx(BaseSelectWrapper, { mode: mode, scale: size, children: isCreatable ? (_jsx(CreatableSelect, { "aria-label": name, classNamePrefix: "mf-select", menuPosition: "absolute", id: name, isDisabled: disabled, isMulti: multi, isClearable: isClearable, mode: mode, name: name, formatCreateLabel: formatCreateLabel, menuIsOpen: hideDropdownUntilSearch ? menuIsOpen : undefined, onInputChange: (inputValue) => {
                handleOnInputChange(inputValue);
                if (useMatchSorter) {
                    setCurrentOptions(matchSorter(options, inputValue, { keys: ['label'] }));
                }
            }, noOptionsMessage: () => noOptionsMessage, onChange: (options) => {
                onChange(options);
            }, options: useMatchSorter ? currentOptions : options, placeholder: placeholder, scale: size, ...rest })) : (_jsx(ReactSelect, { "aria-label": name, classNamePrefix: "mf-select", menuPosition: "absolute", id: name, isDisabled: disabled, isMulti: multi, isClearable: isClearable, mode: mode, name: name, menuIsOpen: hideDropdownUntilSearch ? menuIsOpen : undefined, onInputChange: (inputValue) => {
                handleOnInputChange(inputValue);
                if (useMatchSorter) {
                    setCurrentOptions(matchSorter(options, inputValue, { keys: ['label'] }));
                }
            }, noOptionsMessage: () => noOptionsMessage, onChange: (options) => {
                onChange(options);
            }, options: useMatchSorter ? currentOptions : options, placeholder: placeholder, scale: size, ...rest })) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
BaseSelect.displayName = 'BaseSelect';
export default BaseSelect;
//# sourceMappingURL=BaseSelect.js.map